import { Icon } from "components";
import { DOWNLOAD, FILETEXT } from "icons";
import { Button } from "ui/components/button";
import { assetUrl } from "utils/index";
import { formatFileSize, handleDownload, IMAGE_TYPES } from "./assets-grid-item";

export default function AssetsListItem({ asset }) {
    if (!asset) return null;

    const extension = asset.type?.split("/")?.[1] || asset?.type || "file";
    const imageUrl = assetUrl(asset.id);
    const isImage = IMAGE_TYPES.some((type) => asset.type?.includes(type));

    return (
        <div className="flex items-center gap-4 py-2 border-b border-border hover:bg-muted/50 group">
            <div className="size-10 flex items-center justify-center shrink-0">
                {isImage ? (
                    <img
                        src={imageUrl}
                        alt={asset.title}
                        className="size-8 object-contain rounded"
                        loading="lazy"
                    />
                ) : (
                    <Icon icon={FILETEXT} className="size-6 text-muted-foreground" />
                )}
            </div>

            <div className="flex-1 min-w-0">
                <div
                    className="text-sm font-medium truncate"
                    title={asset.title}
                >
                    {asset.title}
                </div>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                    <span className="uppercase">{extension}</span>
                    <span>•</span>
                    <span>{formatFileSize(Number(asset.filesize))}</span>
                </div>
            </div>

            <div className="opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer mr-4">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => handleDownload(asset.id, asset.title)}
                >
                    <Icon icon={DOWNLOAD} className="size-4" />
                </Button>
            </div>
        </div>
    );
}